import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIDashboard from "./test-ops-dashboard";
// Global visual upgrade for native <select> elements across the app.
// IMPORTANT: import AFTER SoftUIDashboard so it overrides Bootstrap's
// own form-select / form-control rules (last import wins in CSS cascade
// when specificity is equal).
import "./assets/css/base-select-global.css";
import "./assets/css/status-pills-global.css";
import "./assets/css/app-scale.css";
import BaseSelect from "./components/BaseSelect.vue";
import { ensureWebConfigLoaded } from "@/config/loadWebConfig";
import { ensureLatestBuild } from "@/config/ensureLatestBuild";

async function bootstrap() {
  await ensureLatestBuild();

  const appInstance = createApp(App);
  appInstance.use(store);
  appInstance.use(router);
  appInstance.use(SoftUIDashboard);
  // Register BaseSelect globally so any page can use <base-select> without imports.
  appInstance.component("BaseSelect", BaseSelect);

  appInstance.mount("#app");
  ensureWebConfigLoaded();
}

bootstrap();
